import React from "react";
import { connect } from 'react-redux'
import axios from 'axios'

import LeftContent from "./LeftContent";
import FilterPane from './FilterPane';
import OrderSwitcher from './OrderSwitcher';

import { SetUrlBuild, ParseUrl } from '../Commons/SetUrlBuild';

import { fetchInfo } from "../../actions/index.js";
import { getOrders, getMoreOrders } from '../../actions/orderActions';
import { whereBallsMove, getHeader } from "../../helper";

class Orders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            switchMapList: true,
            optionContractor: "contractor",
            optionCustomer: "customer",
            option: 'contractor',
            id: '',

            address: '',

            switchMapList: true,

            filters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                order_by: "location",
                radius: null,
                orderposition__order_method_type_id: null,
            },
            currentFilters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null,
            }
        }

        this.handleChangeAddress = this.handleChangeAddress.bind(this)
        this.handleChangeAddressText = this.handleChangeAddressText.bind(this)
        this.handleChangeDate = this.handleChangeDate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.resetFilters = this.resetFilters.bind(this)
    }

    componentWillMount() {
        const { dispatch } = this.props

        dispatch(fetchInfo([
            {
                query: 'order_method_type'
            }
        ]));
    }
    
    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(3);

        ParseUrl((q, latitude, longitude, order_date_at, radius, order_by, orderposition) => {
            this.setState({
                filters: {
                    q,
                    latitude,
                    longitude,
                    order_date_at,
                    radius: radius,
                    order_by: order_by || this.state.filters.order_by,
                    orderposition__order_method_type_id: orderposition
                },
                currentFilters: {
                    q,
                    latitude,
                    longitude,
                    order_date_at,
                    radius: radius,
                    order_by: order_by || this.state.filters.order_by,
                    orderposition__order_method_type_id: orderposition
                },
            }, () => {
                const {params} = this.props.match;
                let option = this.checkOptionParam(params.option);

                this.getOrderList(option, params.id);
            })
        });
    }

    componentWillReceiveProps (nextProps) {
        const { option, id } = this.props.match.params;
        const nextParams = nextProps.match.params;
        let _option;

        if(option !== nextParams.option || id !== nextParams.id){
            _option = nextParams.option || "customer";
            this.setState({
                option: _option
            }, () => {
                this.resetFilters();
                this.getOrderList(_option, nextParams.id)
            });
        }
    }

    getAddressByCoordinates(lat, lng) {
        axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyAG8F_bb70iYVe6mG1i1DQ_KUeaJRLEgNM`)
        .then(response => {
            // console.log("response google", response.data)
            let res = Object.assign([], response.data.results);
            if(res.length) {
                this.setState({
                    address: res[0].formatted_address,
                    currentFilters: {
                        ...this.state.currentFilters,
                        address: res[0].formatted_address,
                    }
                });
            }
        })
        .catch(error => {
            console.error("GetProducts more Error:", error)
        })
    }

    toggleSwitchMapList(value) {
        const {data} = this.props.orderList;

        if(value !== this.state.switchMapList) {
            this.setState({switchMapList: value});

            if(!value && data.results && data.results.length < 50 && data.next) {
                this.getOrdersWhenMapActive({page_size: 50})
            }
        }
    }

    getOrderList(option, params_id, updateFromFilter) {
        const { dispatch, orderList:{data} } = this.props;
        let someParams = {};
        let param_url = this.getParams2(option, params_id);
        
        if(
            !this.state.switchMapList &&
            data.results && data.results.length < 50
        ) {
            someParams = {page_size: 50};
        }

        const {latitude, longitude} = this.state.filters

        if(latitude && longitude && this.state.address === '') {
            this.getAddressByCoordinates(latitude, longitude);
        }
        
        dispatch(
            getOrders(
                {uri: param_url, ...this.state.filters, ...someParams},
                {...getHeader()}
            )
        );
    }

    getOrdersWhenMapActive(someParams = {}) {
        const {params} = this.props.match;
        let option = this.checkOptionParam(params.option);
        let params2 = this.getParams2(option, params.id);

        this.props.dispatch(
            getOrders(
                {uri: params2, ...this.state.filters, ...someParams},
                {...getHeader()}
            )
        );
    }

    getParams2(param_type, param_id) {
        if(param_type !== this.state.optionCustomer && param_type !== this.state.optionContractor){
            param_type = this.state.optionCustomer
        }

        if(!param_id) {
            param_id = 'all_my';
        }

        return param_type + "_" + param_id;
    }

    handleSubmit() {
        let id = this.props.match.params.id;

        SetUrlBuild(this.state.filters);
        this.getOrderList(this.state.option, id, true);

        this.setState({
            currentFilters: {...this.state.filters, address: JSON.parse(JSON.stringify(this.state.address))}
        });
    }

    handleMoreOrders(count) {
        if (!count) return false;

        const { dispatch, match } = this.props;
        let {params: {option, id}} = match;
        let paramURL = this.getParams2(option, id);

        dispatch(getMoreOrders({
            params: {uri: paramURL, offset: count, ...this.state.filters },
            headers: getHeader()
        }));
    }

    resetFilters(e) {
        if(e){
            e.preventDefault();
        }

        this.setState({
            address: '',
            filters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null
            },
            currentFilters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null,
            }
        })
    }

    handleChangeAddressText(address) {
        if(!address.trim()){
            this.setState({
                filters: Object.assign({}, this.state.filters, {
                    latitude: null,
                    longitude: null
                })
            })
        }

        this.setState({address});
    }

    handleChangeAddress(address) {
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                latitude: address.lat,
                longitude: address.lng
            })
        })
    }

    handleOnChange(field, value) {
        value = (field === 'orderposition__order_method_type_id' && parseInt(value) === 0)  ? null : value;
        
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                [field]: value
            })
        })
    }

    handleChangeDate(date) {
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                order_date_at: date
            })
        })
    }

    checkOptionParam(option) {
        
        let _option = this.state.optionCustomer;
        if(option === this.state.optionCustomer || option === this.state.optionContractor){
            _option = option;
        }
        else {
            this.props.history.push("/orders")
        }

        this.setState({option: _option});
        return _option;
    }

    render() {
        let { id } = this.props.match.params;
        const { order_method_type } = this.props.data;

        return(
            <div className="vertical-scrolling page thirdSection sectionOrders" id="sectionOrders" data-main-nav-id="ordersNavLink">
                <div className="container content">
                    <LeftContent option={this.state.option} id={id}/>

                    <div className="right-content native-scroll executorRightContent tab-parent right-content-out right-content-width">
                        <div className="screen-outer-block-wrap native-scroll">
                                <FilterPane
                                        filterValues={{
                                            ...this.state.filters,
                                            address: this.state.address
                                        }}
                                        currentFilterValues={{
                                            ...this.state.currentFilters,
                                        }}
                                        handleSubmit={this.handleSubmit}
                                        resetFilters={this.resetFilters}
                                        handleOnChange={this.handleOnChange.bind(this)}
                                        handleChangeAddress={this.handleChangeAddress}
                                        handleChangeAddressText={this.handleChangeAddressText}
                                        handleChangeDate={this.handleChangeDate}
                                        orderMethodType={order_method_type}/>

                            <OrderSwitcher
                                option={this.state.option}
                                params={this.props.match.params}
                                switchMapList={this.state.switchMapList}
                                handleMoreOrders={(count) => this.handleMoreOrders(count)}
                                toggleSwitchMapList={(value) => this.toggleSwitchMapList(value)}
                                handleGetOrders={(params) => this.getOrdersWhenMapActive(params)}
                            />
                        </div>
                    </div>
                    
                    {/* <ExecutorSeeOrderRightContent/>
                    <CustomerSeeOrderRightContent/> */}
                </div>
            </div>
          )
    }
}

export default connect(
	state => ({
		...state
	})
)(Orders);


// WEBPACK FOOTER //
// ./src/components/Orders/index.js